import React from "react";

import "./order.css";

function Banner({ handleSelectionMenuPlan, selectionPlan }) {

  return (
    <>
      <div className="banner_container">
        <div className="banner_content_container">
          <div className="banner_img_div">
            <img
              src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
              alt="bannerImg"
            />
          </div>
          <div className="banner_text_div">
            <h5>Customize Menu for your Kids</h5>
            <p>
              North Indian, South Bangla, Chinese, Fast Food, Juices, Biryani,
              Punjabi Manik Baug, Sinhgad Road
            </p>
            <h6>SELECT YOUR MEMBERSHIP</h6>
            <div className="menu_selection_container">
              <div
                className="menu_selection_box"
                style={{ backgroundColor: `${selectionPlan === "monthly" ? "#FBA922" : "#FFF"}`, cursor: "pointer" }}
                onClick={() => handleSelectionMenuPlan("monthly")}
              >
                <p style={{ color: `${selectionPlan === "monthly" ?"#FFF" : "#000"}` }}>
                  Monthly <br />
                  <span style={{ fontSize: "13px" }}>(NOK 200)</span>
                </p>
              </div>
              <div
                className="menu_selection_box"
                style={{ backgroundColor: `${selectionPlan === "weekly"? "#FBA922" : "#FFF"}`, cursor: "pointer" }}
                onClick={() => handleSelectionMenuPlan("weekly")}
              >
                <p style={{ color: `${selectionPlan === "weekly" ?"#FFF" : "#000"}` }}>
                  Weekly <br />
                  <span style={{ fontSize: "13px" }}>(NOK 50)</span>
                </p>
              </div>
              <div
                style={{backgroundColor: `${selectionPlan === "daily"? "#FBA922" : "#FFF"}`, cursor: "pointer"}}
                className="menu_selection_box"
                onClick={() => handleSelectionMenuPlan("daily")}
              >
                <p style={{ color: `${selectionPlan === "daily" ?"#FFF" : "#000"}` }}>
                  Daily <br />
                  <span style={{ fontSize: "13px" }}>(NOK 10)</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr className="banner_hr_line" />
      </div>
    </>
  );
}

export default Banner;
